import { NavLink } from 'react-router-dom'
import styled, { css } from 'styled-components'

import {
  desktopMediaQuery,
  mainColors,
  rgba,
  tabletOrMobileMediaQuery,
  zIndex,
} from '@avantstay/backoffice-core'

import { HEADER_HEIGHT } from '@styles/constants'

export const HeaderGroup = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
  position: relative;
`

export const Root = styled(HeaderGroup)`
  z-index: ${zIndex.FOLD_OUT_MENU};
  position: sticky;
  top: 0;
  justify-content: space-between;
  padding: 0 30px;
  width: 100%;
  min-height: ${HEADER_HEIGHT};
  max-height: ${HEADER_HEIGHT};
  background-color: ${mainColors.primaryDark};
  box-shadow: 0 2px 4px 0 ${rgba(mainColors.black, 0.1)};

  ${tabletOrMobileMediaQuery`
    padding: 0 16px;
  `}
`

export const HeaderGroupLogo = styled(HeaderGroup)`
  ${desktopMediaQuery`
    flex-grow: 1;
    flex-basis: 25%;
  `}
`

export const HeaderGroupDesktopMenu = styled(HeaderGroup)`
  flex-grow: 2;
  flex-basis: 50%;
  justify-content: center;
`

export const HeaderGroupSearch = styled(HeaderGroup)`
  flex-grow: 1;
  flex-basis: 25%;
  justify-content: flex-end;

  ${tabletOrMobileMediaQuery`
    margin-left: 0px;
  `}
`

export const LogoNavLink = styled(NavLink)`
  line-height: 100%;
`

export const HeaderNav = styled.nav`
  position: relative;
  display: flex;
  gap: 2px;
  height: 100%;
  background-color: transparent;
  padding: 0;
  min-width: 80%;
  justify-content: space-between;

  a {
    margin-bottom: 0;
  }
`

const headerLinkCommonStyles = css`
  width: 64px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  font-size: 11px;
  font-weight: 500;
  color: ${rgba(mainColors.neutralExtremelyDark, 0.8)};
  text-decoration: none;
  position: relative;
  overflow: hidden;

  > svg {
    color: ${mainColors.neutralExtremelyDark};
  }

  &:hover {
    &,
    > svg {
      color: ${mainColors.neutralExtraDark};
    }
  }

  @media (max-width: 1024px) {
    font-size: 10px;
  }
`

export const HeaderLink = styled(NavLink)<{ $isActive?: boolean }>`
  ${headerLinkCommonStyles};

  &.active {
    &,
    > svg {
      color: ${mainColors.accentLight};
    }
    &:after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: -4px;
      height: 8px;
      border-radius: 4px;
      background-color: ${mainColors.accentLight};
    }
  }

  ${({ $isActive }) =>
    $isActive &&
    `
    color: ${mainColors.accentLight};

    svg {
      color: ${mainColors.accentLight};
    }

    &:after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: -4px;
      height: 8px;
      border-radius: 4px;
      background-color: ${mainColors.accentLight};
    }
  `}
`

export const HeaderExternalLink = styled.a`
  ${headerLinkCommonStyles};
`

export const HeaderAvatarContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 46px;
  text-align: center;
  margin-left: 20px;

  > div {
    vertical-align: middle;
  }
`

export const ClickableAvatar = styled.button`
  background: transparent;
`
